import { render, staticRenderFns } from "./diagens_overview.vue?vue&type=template&id=23368c74&scoped=true"
import script from "./diagens_overview.vue?vue&type=script&setup=true&lang=js"
export * from "./diagens_overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./diagens_overview.vue?vue&type=style&index=0&id=23368c74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23368c74",
  null
  
)

export default component.exports